/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectionManagementWizard/useRejectionManagementEmailForm"/>
import { FieldValues, useForm } from "react-hook-form";
import { IRecipientAddress } from "./interfaces";

export interface RejectionManagementEmailWizardFormState {
    emailTo: IRecipientAddress[];
    carbonCopy: IRecipientAddress[];
    messageSubject: string;
    sendCopy: boolean;
    content: string;
    sendToSupplier: boolean;
}

export const defaultState: RejectionManagementEmailWizardFormState = {
    emailTo: [{value: ""}],
    carbonCopy: [{value: ""}],
    messageSubject: "",
    sendCopy: true,
    content: "",
    sendToSupplier: true,
};

export const useRejectionManagementEmailForm = () => {
  const { handleSubmit, control, reset, watch, formState, setError, clearErrors, setValue, getValues } = useForm({
    criteriaMode: "all",
    mode: "onChange",
    defaultValues: defaultState as FieldValues,
    reValidateMode: "onChange",
  });

  return { handleSubmit, control, reset, watch, defaultState, formState, setError, clearErrors, setValue, getValues };    
};
